//@author: devin
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    NgZone,
    ViewEncapsulation,
} from "@angular/core";
import { S25ItemComponent } from "../s25.item.component";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { tooltipRowType } from "../../../services/tooltip.service";

@TypeManagerDecorator("s25-item-event")
@Component({
    selector: "s25-item-event",
    host: {
        class: "s25-object-event",
    },
    template: `
        @if (init) {
            <s25-item
                [modelBean]="modelBean"
                [includeTypeIcon]="includeTypeIcon"
                [popoverTemplate]="eventTooltip"
                [empty]="empty"
                [inactive]="inactive"
                [ariaLabel]="ariaLabel"
                [contextMenuOnBody]="contextMenuOnBody"
                [dataService]="dataService"
                [dataServiceContext]="dataServiceContext"
                [newTab]="newTab"
                [blockDetailsNav]="blockDetailsNav"
                ><ng-content></ng-content
            ></s25-item>
        }

        <ng-template #eventTooltip>
            <div class="qtip-content">
                @if (!modelBean.initPopOver) {
                    <div>Loading...</div>
                }
                @if (modelBean.initPopOver && !modelBean.data?.item) {
                    <div class="eventBox popoverroot">Could not load event details</div>
                }
                @if (modelBean.initPopOver && modelBean.data?.item) {
                    <div class="eventBox popoverroot">
                        <div
                            class="boxHeader"
                            (contextmenu)="contextMenu({ itemTypeId: 1, itemId: modelBean.itemId }, $event)"
                        >
                            <div class="boxHeaderName">{{ modelBean.data.item.event_name }}</div>
                        </div>
                        <div class="boxBody">
                            @if (modelBean.data.item.rows) {
                                <div>
                                    @for (row of modelBean.data.item.rows.data; track trackByFn($index, row)) {
                                        <div>
                                            <div>
                                                @if (row.type !== tooltipRowType.EventTime) {
                                                    <span class="c-dataLabel">{{ row.name }}</span>
                                                }
                                                @if (
                                                    row.type == tooltipRowType.EventTime &&
                                                    modelBean.data.item.rsrv_start_dt
                                                ) {
                                                    <span class="c-dataLabel">{{ row.name }}</span>
                                                }
                                            </div>
                                            <ng-container
                                                [ngTemplateOutlet]="rowTemplate"
                                                [ngTemplateOutletContext]="{ row }"
                                            />
                                        </div>
                                    }
                                    @for (loc of modelBean.data?.item?.spaces?.data; track trackByFn($index, loc)) {
                                        @if (modelBean.data?.item?.spaces) {
                                            <div class="dataItemSpaces">
                                                <span class="c-dataLabel">{{
                                                    ($index === 0 && "Location(s): ") || " "
                                                }}</span>
                                                <div class="ngItemSpace">
                                                    @if (loc.is_hidden != 1) {
                                                        <span
                                                            class="ngInline s25-object s25-object-space summary"
                                                            (click)="
                                                                itemDetail(
                                                                    { itemTypeId: 4, itemId: loc.space_id },
                                                                    $event
                                                                )
                                                            "
                                                            (contextmenu)="
                                                                contextMenu(
                                                                    { itemTypeId: 4, itemId: loc.space_id },
                                                                    $event
                                                                )
                                                            "
                                                        >
                                                            <div
                                                                class="icon-space ngInline s25-object s25-object-space summary"
                                                            ></div>
                                                            <div class="ngInline s25-object s25-object-space summary">
                                                                {{ loc.space_name }}
                                                            </div>
                                                        </span>
                                                    }
                                                    @if (loc.is_hidden == 1) {
                                                        <span class="ngInline">
                                                            <div class="icon-space ngInline"></div>
                                                            <div class="ngInline">{{ loc.space_name }}</div>
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </ng-template>

        <ng-template #rowTemplate let-row="row">
            <div>
                @if (row.type === tooltipRowType.LabelledList) {
                    <span>
                        <ul class="labelledList">
                            @for (item of row.value; track $index) {
                                <li>
                                    <label>{{ item.label }}:</label>
                                    @if (item.nested) {
                                        <ng-container
                                            [ngTemplateOutlet]="rowTemplate"
                                            [ngTemplateOutletContext]="{ row: item.value }"
                                        />
                                    } @else {
                                        <span>{{ item.value }}</span>
                                    }
                                </li>
                            }
                        </ul>
                    </span>
                }
                @if (row.type === tooltipRowType.Bullets) {
                    <span>
                        <ul>
                            @for (item of row.value; track $index) {
                                <li>
                                    @if (item.nested) {
                                        <ng-container
                                            [ngTemplateOutlet]="rowTemplate"
                                            [ngTemplateOutletContext]="{ row: item.value }"
                                        />
                                    } @else {
                                        {{ item.value }}
                                    }
                                </li>
                            }
                        </ul>
                    </span>
                }
                @if (row.type === tooltipRowType.Item) {
                    <span>
                        <s25-item-generic
                            [itemTypeId]="row.value.itemTypeId"
                            [itemId]="row.value.itemId"
                            [itemName]="row.value.itemName"
                        />
                    </span>
                }
                @if (row.type == tooltipRowType.Raw) {
                    <span>{{ row.value }}</span>
                }
                @if (row.type == tooltipRowType.HTML) {
                    <span [innerHTML]="row.value"></span>
                }
                @if (row.type === tooltipRowType.Template) {
                    <ng-container
                        [ngTemplateOutlet]="row.value.template"
                        [ngTemplateOutletContext]="row.value.context"
                    />
                }
                @if (row.type == tooltipRowType.EventTime && modelBean.data.item.rsrv_start_dt) {
                    <span>
                        <span>
                            {{ modelBean.data.item.rsrv_start_dt | dateFormat: modelBean.data.timeFormat }}
                            @if (
                                (modelBean.data.item.rsrv_start_dt | dateFormat: modelBean.data.dateFormat) !==
                                (modelBean.data.item.rsrv_end_dt | dateFormat: modelBean.data.dateFormat)
                            ) {
                                <span class="meridiem angular fulldate">
                                    {{
                                        " (" +
                                            (modelBean.data.item.rsrv_start_dt
                                                | dateFormat: modelBean.data.dateFormat) +
                                            ")"
                                    }}
                                </span>
                            }
                            <span class="meridiem">{{ " - " }}</span>
                        </span>
                        <span>
                            {{ modelBean.data.item.rsrv_end_dt | dateFormat: modelBean.data.timeFormat }}
                            @if (
                                (modelBean.data.item.rsrv_start_dt | dateFormat: modelBean.data.dateFormat) !==
                                (modelBean.data.item.rsrv_end_dt | dateFormat: modelBean.data.dateFormat)
                            ) {
                                <span class="meridiem angular fulldate">
                                    {{
                                        " (" +
                                            (modelBean.data.item.rsrv_end_dt | dateFormat: modelBean.data.dateFormat) +
                                            ")"
                                    }}
                                </span>
                            }
                        </span>
                    </span>
                }
            </div>
        </ng-template>
    `,
    styles: `
        ul,
        ol {
            padding-left: 0;
            font-size: 0.9em;
            margin: 0;
            list-style-position: inside;

            span {
                padding: 0 !important;
            }

            > li > * {
                display: inline-block;
            }
        }

        .labelledList {
            list-style-type: none;

            label {
                font-style: italic;
                font-weight: 400;
                min-width: 6em;
            }
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25ItemEventComponent extends S25ItemComponent {
    constructor(elementRef: ElementRef, zone: NgZone, cd: ChangeDetectorRef) {
        super(elementRef, zone, cd);
    }

    ngOnInit() {
        this.itemTypeId = 1;
        super.ngOnInit();
    }

    protected readonly tooltipRowType = tooltipRowType;
}
